import type { Dict } from 'mixpanel-browser';
import { gtag } from '../plugins/gtag';
import { loadMixpanel } from '../plugins/mixpanel';

export function tag(name: string, data: Dict) {
  console.log('[tag] TAG:', name, data);
  void loadMixpanel().then((mixpanel) => {
    mixpanel.track(name, data);
  });
  gtag('event', name, data);
}

export function identify(data: Dict) {
  console.log('[tag] IDENTIFY:', data);
  void loadMixpanel().then((mixpanel) => {
    mixpanel.identify(data.id);
    mixpanel.people.set({
      ...data,
      $id: data.id,
      $email: data.email,
      $name: data.displayName,
    });
  });
  gtag('config', 'user', data.id);
}

export function config(name: string, data: Dict) {
  console.log('[tag] CONFIG:', data);
  gtag('config', name, data);
  loadMixpanel().then((mixpanel) => mixpanel.register({ [name]: data }));
}
